
class RecentlyViewed extends HTMLElement {
    template; handles; max; products = [];
    static selectors = {
      template: '[data-template]',
      productTemplate: '[data-product]',
    }

    constructor(){
      super();
      this.init();
    }
  
    init = () => {
      this.template = this.querySelector(RecentlyViewed.selectors.template).innerHTML;
      this.handles = Utils.getViewed();
      this.max = parseInt(this.dataset.max) || 4;

      if(this.template && this.handles.length > 0){
        this.update(0);
      }

    }

    update = (index) => {
      if(index < this.max){
        var handle = this.handles[index];
        if(handle == undefined){
          this.renderTemplate();
        } else {
          Utils.getProductByHandle(this.handles[index], (product) => {
            this.products.push(product);
            this.update(index + 1);
          });
        }
      } else {
        this.renderTemplate();
      }
    }

    renderTemplate = () => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.template, 'text/html');
      const productTemplate = doc.querySelector(RecentlyViewed.selectors.productTemplate).outerHTML;
      const parentElement = doc.querySelector(RecentlyViewed.selectors.productTemplate).parentElement;
      doc.querySelector(RecentlyViewed.selectors.productTemplate).remove();
      this.products.forEach((product) => {
        var temp = productTemplate;
        temp = temp.replaceAll('TITLE', product.title);
        temp = temp.replaceAll('VENDOR', product.vendor);
        temp = temp.replaceAll('PRICE', Utils.money(product.price));
        temp = temp.replaceAll('URL', product.url);
        temp = temp.replaceAll('IMAGE', product.featured_image);
        parentElement.appendChild(new DOMParser().parseFromString(temp, 'text/html').body.firstChild);
      });
      this.innerHTML = doc.body.innerHTML;
    }
    
  }
  if (!window.customElements.get("recently-viewed")) {
    window.customElements.define("recently-viewed", RecentlyViewed);
  }